import React, { useRef, useEffect, useContext, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { components, useServices } from 'cng-web-lib'
import { Grid, Box, Card, Tooltip } from '@material-ui/core'
import ACEHighwayManifestTranslationText from '../../contexts/ACEHighwayManifestTranslationText'
import CngSection from 'src/components/cngcomponents/CngSection'
import Switch from 'src/components/Switch'
import PartyInfoFormProperties from '../PartyInfoFormProperties'
import PAXLSTFormProperties from '../PAXLSTFormProperties'
import CrewMasterApiUrls from "src/apiUrls/CrewMasterApiUrls"
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import PopulatePaxlstDialog from '../PopulatePaxlstDialog'
import moment from 'moment-timezone'

const { button: { CngIconButton, CngButton } } = components

const { initialValues } = PartyInfoFormProperties.formikProps

function CrewInformationSection(props) {
    const { setRequirePaxlst, requirePaxlst, setShowDriver, showDriver } = props
    const { setValue, getValues } = useFormContext();
    const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText() 

    const status = useWatch({ name: 'status' })
    const messageIndicator = useWatch({ name: 'messageIndicator' })
    const partyInfo = useWatch({ name: 'partyInfo' })
    const lastIndex = useRef(partyInfo.length - 1)
    const { securedSendRequest } = useServices();
    const [showPopulatePaxlstDialog, setShowPopulatePaxlstDialog] = useState(false)

    // Push party info default value with crew type 'Driver' if there isn't any
    useEffect(() => {
        const { initialValues } = PartyInfoFormProperties.formikProps

        if (partyInfo.length === 0) {
            setValue('partyInfo', [{ ...initialValues, partyType: 'VW', _id: 1 }])
        } else {
            const hasDriver = partyInfo.findIndex(party => party.partyType === 'VW') !== -1

            if (!hasDriver) {
                const result = [...getValues('partyInfo')]
                result.push({ ...initialValues, partyType: 'VW' })

                setValue('partyInfo', result.map((party, index) => ({ ...party, _id: index + 1 })))
            }
        }
    }, [partyInfo])

    function handleAddPartyInfo(data) {
        const partyInfo = [...getValues('partyInfo'), { ...data, _id: ++lastIndex.current }]
        setValue('partyInfo', partyInfo)
    }

    function handleDeletePartyInfo(data) {
        const partyInfo = [...getValues('partyInfo')].filter((party) =>
            party.id ? party.id !== data.id : party._id !== data._id
        )

        setValue('partyInfo', partyInfo)
    }

    function paxlstRequiredAction() {
        setRequirePaxlst(true)
        setValue('paxLSTFlag', true)
        setShowPopulatePaxlstDialog(true)

        if (!status || status === '1005') {
            console.log('Auto change message function to Multistep Add')
            setValue('messageFunction', '2')
        }
    }

    function paxlstNotRequiredAction() {
        setRequirePaxlst(false)
        setValue('paxLSTInfo', [])
        setValue('autoSubmitPaxLst', false)
        setValue('autoConfirmManifest', false)
        if (messageIndicator !== 'MULTI' || !status || status === '1005') {
            setValue('paxLSTFlag', false)
        }

        if (!status || status === '1005') {
            console.log('Auto change message function to Singlestep Add')
            setValue('messageFunction', '22')
        }
    }

    function populatePaxlstInfo() {
        let passengerList = partyInfo.filter(val => val.partyType == "FL")

        if (passengerList.length == 0) {
            createDefaultPaxlstEntry()
        }

        const partyTypeToProcess = ["FL", "VW", "FM"]

        for (const partyTypeElement of partyTypeToProcess) {
            setPaxlstInfo(partyTypeElement, partyInfo)
        }
    }

    function createDefaultPaxlstEntry() {
        console.log("Creating default PAXLST entry")

        const { initialValues } = PAXLSTFormProperties.formikProps
        const paxlst = [{
            ...initialValues,
            _id: 0,
            partyType: 'FL',
            status: 'DR'
        }]

        setValue('paxLSTInfo', paxlst)
    }

    function setPaxlstInfo(partyTypeToProcess, partyList) {
        const { initialValues } = PAXLSTFormProperties.formikProps

        for (const element of partyList) {
            let partyType = element.partyType;

            if (partyType == partyTypeToProcess) {
                let paxlstList = getValues('paxLSTInfo')
                let id = paxlstList.length

                let filters = {
                    baseFilterDTO: {
                        filterType:"AND",
                        filterProperties: [
                            { fieldName: "partyId", operatorType: "EQUAL", value1: FileForUserGetPartyId() },
                            { fieldName: "inputSource", operatorType: "EQUAL", value1: "aceHwyManifestCrew" }
                        ],
                    sortProperties: []
                    }
                }

                let paxlstObj = { 
                    ...initialValues,
                    partyType: partyType,
                    status: 'DR'
                }

                paxlstObj._id = id

                if (element.crewId != "" && element.crewId != null) {
                    filters.baseFilterDTO.filterProperties.push({ fieldName: "crewId", operatorType: "EQUAL", value1: element.crewId })
                } else if (element.aceId != "" && element.aceId != null) {
                    filters.baseFilterDTO.filterProperties.push({ fieldName: "aceId", operatorType: "EQUAL", value1: element.aceId })
                } else if (element.fastCard != "" && element.fastCard != null) {
                    filters.baseFilterDTO.filterProperties.push({ fieldName: "fastCard", operatorType: "EQUAL", value1: element.fastCard })
                }

                securedSendRequest.execute('POST', CrewMasterApiUrls.GET, filters,
                    (response) => {
                        let data = response.data

                        if (data != null && data != '') {
                            if (data.content.length > 0) {
                                let content = data.content[0]
                                paxlstObj.firstName = content.firstName
                                paxlstObj.lastName = content.lastName
                                paxlstObj.gender = content.gender
                                paxlstObj.dob = covertDateFormat(content.dob)
                                paxlstObj.nationality = content.nationality
                                paxlstObj.licenseNo = content.licenseNo
                                paxlstObj.licenseCountry = content.licenseCountry
                                paxlstObj.licenseState = content.licenseState
                                paxlstObj.cdlNo = content.cdlNo
                                paxlstObj.cdlCountry = content.cdlCountry
                                paxlstObj.cdlState = content.cdlState
                                paxlstObj.address1 = element.address1
                                paxlstObj.address2 = element.address2
                                paxlstObj.address3 = element.address3
                                paxlstObj.cityName = element.cityName
                                paxlstObj.postalCode = element.postalCode
                                paxlstObj.country = element.country
                                paxlstObj.state = element.state
                                paxlstObj.internationalDoc = convertTravelDocType(content.internationalDoc)
                            } else {
                                paxlstObj.address1 = element.address1
                                paxlstObj.address2 = element.address2
                                paxlstObj.address3 = element.address3
                                paxlstObj.cityName = element.cityName
                                paxlstObj.postalCode = element.postalCode
                                paxlstObj.country = element.country
                                paxlstObj.state = element.state
                            }
                        }

                        paxlstList.push(paxlstObj)
                        setValue('paxLSTInfo', paxlstList)
                    },
                    (error) => {
                        console.error(error)
                        paxlstList.push(paxlstObj)
                        setValue('paxLSTInfo', paxlstList)
                    }
                )
            }
        }      
    }

    function convertTravelDocType(internationalDoc) {
        const highwayPaxlstInterchange = [
                { id: '39', value: 'AIG' }, 
                { id: 'AEW', value: 'DM' }, 
                { id: '6W', value: 'ACE' }, 
                { id: 'AGS', value: 'AQY' }, 
                { id: 'AEF', value: 'ARJ' }, 
                { id: 'AGR', value: 'ASX' }, 
                { id: 'ALR', value: 'ALR' }, 
                { id: 'ALX', value: 'AVP' },
                { id: '989', value: 'AUB' }, 
                { id: 'AGT', value: 'GN' }, 
                { id: 'ALY', value: 'AFZ' }, 
                { id: 'ACU', value: 'ET' }, 
                { id: 'AAG', value: 'AGF' }, 
                { id: 'ALV', value: 'ALV' }, 
                { id: 'BCP', value: 'CR' }, 
                { id: 'REP', value: 'REP' }, 
                { id: 'RTP', value: 'RTP' }, 
                { id: 'BCN', value: 'BCN' }, 
                { id: 'CDN', value: 'CDN' }, 
                { id: 'CON', value: 'CON' }, 
                { id: 'OTD', value: 'OTD' }
            ]   

        for (let i = 0; i < internationalDoc.length; i++) {
            const convertedDocType = highwayPaxlstInterchange.find(docType => docType.value == internationalDoc[i].docType)

            if (convertedDocType != undefined) {
                internationalDoc[i].docType = convertedDocType.id
            }
        }

        return internationalDoc
    }

    function covertDateFormat(input) {
        if (input != '' && input != null) {
            let result = moment(input).tz("Canada/Eastern").format('YYYY-MM-DD')

            return result
        } else {
            return ''
        }
    }

    return (
        <><Grid item xs={12}>
            <CngSection title={aceHighwayManifestTranslationText.crewInformation}
                helperText={aceHighwayManifestTranslationText.crewSectionHelper}
                alignItems='flex-end'
                id="crew-info"
            >
                {showDriver &&
                    <Grid container spacing={1}>
                        {partyInfo.map((party, index) => (
                            <Grid key={index} item xs={12}>
                                <Card variant='outlined'>
                                    <Box padding={2}>
                                        <Grid container justify='space-between' spacing={1}>

                                            <Grid item xs={12}>
                                                <PartyInfoFormProperties.Fields index={index} />
                                            </Grid>

                                            <Grid item xs='auto'>
                                                <Grid container spacing={1}>

                                                    <Grid item>
                                                        <Tooltip placement='bottom' title={aceHighwayManifestTranslationText.add}>
                                                            <span>
                                                                <CngIconButton
                                                                    icon={['fal', 'plus']} size='small' type='outlined'
                                                                    onClick={() => handleAddPartyInfo(initialValues)} />
                                                            </span>
                                                        </Tooltip>
                                                    </Grid>

                                                    <Grid item>
                                                        <Tooltip placement='bottom' title={aceHighwayManifestTranslationText.clone}>
                                                            <span>
                                                                <CngIconButton
                                                                    icon={['fal', 'copy']} size='small' type='outlined'
                                                                    onClick={() => handleAddPartyInfo({ ...party, id: undefined })} />
                                                            </span>
                                                        </Tooltip>
                                                    </Grid>

                                                    {partyInfo.length > 1 &&
                                                        <Grid item>
                                                            <Tooltip placement='bottom' title={aceHighwayManifestTranslationText.delete}>
                                                                <span>
                                                                    <CngIconButton
                                                                        icon={['fal', 'trash']} size='small' type='outlined'
                                                                        onClick={() => handleDeletePartyInfo(party)} />
                                                                </span>
                                                            </Tooltip>
                                                        </Grid>}

                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>}
                <Grid container>
                    <Grid item xs={6} md={2} style={{ padding: '5px 4px 0px 0px' }}>
                        <Switch fullWidth label={'Require Paxlst'} checked={requirePaxlst} onChange={(event) => {
                            if (event.target.checked) {
                                paxlstRequiredAction()
                            } else {
                                paxlstNotRequiredAction()
                            }
                        }}
                        />
                    </Grid>
                    {requirePaxlst &&
                        <Grid item xs={6} md={2} style={{ padding: '5px 1px 0px 4px' }}>
                            <Switch fullWidth label={'Show Crew Info'} checked={showDriver} onChange={(event) => {
                                if (event.target.checked) {
                                    setShowDriver(true)
                                } else {
                                    setShowDriver(false)
                                }
                            }}
                            />
                        </Grid>
                    }
                </Grid>
            </CngSection>
            </Grid>
            
            <PopulatePaxlstDialog
                open={showPopulatePaxlstDialog}
                onClose={() => setShowPopulatePaxlstDialog(false)}
                onPopulatePaxlstInfo={populatePaxlstInfo}
                onCreateDefaultPaxlstEntry={createDefaultPaxlstEntry}
            />
        </>
    )
}

export default CrewInformationSection